import {
  getFilterStorageKey,
  getFiltersFromSession,
  saveFiltersToSession,
  mergeFiltersWithUrl
} from "./filterSessionStorage";
import { normalizeRefineParameter } from "../helpers/normalizeRefineParameter";
import { queryStringToObject } from "../helpers/queryStringToObject";
import sdkProvider from "./sdkProvider";

export const EXPERIMENT_KEY = "plp-save-filters";

let featuresSdk;

export const initSaveFiltersExperiment = async () => {
  featuresSdk = await sdkProvider("features");
  await featuresSdk.onReady();
};

export const isSaveFiltersExperimentEnabled = () => {
  let isEnabled = false;
  const cid = new URLSearchParams(window?.location?.search)?.get("cid");

  if (cid) {
    const feature = featuresSdk?.getFeature(EXPERIMENT_KEY, null, {
      app: "plp",
      categoryId: cid
    });

    if (feature?.isEnabled() && feature?.getVariables()?.bucket === "on") {
      isEnabled = true;
    }
  }

  return isEnabled;
};

export const getRestoredFiltersForNavigation = location => {
  if (!isSaveFiltersExperimentEnabled()) {
    return null;
  }

  const query = location.query || queryStringToObject(location.search || "");

  const key = getFilterStorageKey({ query });

  if (!key) {
    return null;
  }

  const savedFilters = getFiltersFromSession(key);
  if (!savedFilters) {
    return null;
  }

  const merged = mergeFiltersWithUrl(query, savedFilters);

  const hasNewFilters =
    normalizeRefineParameter({ refine: merged.refine }) !==
    normalizeRefineParameter({ refine: query.refine });

  if (!hasNewFilters) {
    return null;
  }

  return merged;
};

export const saveCurrentFiltersFromLocation = location => {
  if (!isSaveFiltersExperimentEnabled()) {
    return;
  }

  const query = location.query || queryStringToObject(location.search || "");

  const key = getFilterStorageKey({ query });
  if (!key) {
    return;
  }

  if (!query.refine) {
    return;
  }

  saveFiltersToSession(key, {
    refine: query.refine
  });
};

export const safeDecodeRefineParam = encoded =>
  encoded.replace(/%3A/gi, ":").replace(/%7C/gi, "|");

export const buildLocationWithRestoredFilters = (location, restoredFilters) => {
  const searchParams = new URLSearchParams(location.search || "");
  searchParams.delete("refine");

  const baseString = searchParams.toString();
  const refine = restoredFilters?.refine;
  const refineString = refine
    ? `&${safeDecodeRefineParam(new URLSearchParams({ refine }).toString())}`
    : "";

  return {
    ...location,
    search: `?${baseString}${refineString}`
  };
};
